import React, { ReactNode, useRef, useState } from 'react';
import { Trans } from 'react-i18next';
import i18n, { TFunction } from 'i18next';
import { InteractionStatus } from '../../../types/InteractionStatus';
import { Strong } from '../../atoms/Strong/Strong';
import { MemberRowAction, MemberRowMode, MemberRowStateType } from './MemberRowTypes';

export function useMemberRow(
  onChangeMode: (mode: MemberRowMode | null) => void,
  onRequestFinished: () => void,
  t: TFunction,
  mode?: MemberRowMode | null,
) {
  const [state, setState] = useState<MemberRowStateType>({
    action: '',
  });
  const editButtonRef = useRef<HTMLButtonElement>(null);
  const removeButtonRef = useRef<HTMLButtonElement>(null);

  /**
   * Changes or toggles the rows mode
   * @param mode {string} Identifier of new mode
   */
  const changeOrToggleMode = (modeObj: MemberRowMode | null): void => {
    setState({ action: '' });

    onChangeMode(mode !== modeObj ? modeObj : null);
  };

  /**
   * Handles the submit button click (delete, changeRoles)
   */
  const onSubmit = (event: React.MouseEvent, model: any, actionName: MemberRowAction): void => {
    event.preventDefault();

    model.submit().then(() => {
      onRequestFinished();
    });

    setState({ action: actionName });
  };

  /**
   * Returns a Translation Key depending on the current InteractionStatus
   * @returns {React.JSX.Element}
   */
  const getStatusText = (action: string, status: string): ReactNode => {
    const languageKey = status === InteractionStatus.SENDING ? `status.${status}` : `status.${action}.${status}`;

    return (
      // eslint-disable-next-line react/jsx-key
      <Trans i18nKey={`MemberRow:${languageKey}`} i18n={i18n} t={t as TFunction} components={[<Strong>, </Strong>]} />
    );
  };

  return {
    state,
    editButtonRef,
    removeButtonRef,
    getStatusText,
    changeOrToggleMode,
    onSubmit,
  };
}
